import React from 'react';
import { useForm } from '../../context/FormContext';

const MARITAL_STATUSES = [
  'Single',
  'Married',
  'Cohabiting',
  'Divorced',
  'Separated',
  'Widowed',
  'Civil Partnership',
  'Dissolved Civil Partnership',
  'Engaged'
];

export const MaritalStatusStep = ({ onAutoAdvance }) => {
  const { formData, updateFormData } = useForm();

  const handleSelect = (status) => {
    updateFormData({ marital_status: status });
    setTimeout(() => onAutoAdvance?.(), 300);
  };

  return (
    <div className="space-y-6" data-testid="marital-status-step">
      <div className="text-center">
        <h2 className="text-xl md:text-2xl font-bold text-slate-900 mb-2" style={{ fontFamily: 'Manrope, sans-serif' }}>
          Marital Status
        </h2>
        <p className="text-slate-600 hidden md:block">Are you...</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {MARITAL_STATUSES.map(status => (
          <button
            key={status}
            onClick={() => handleSelect(status)}
            className={`p-4 rounded-xl border-2 transition-all text-center ${
              formData.marital_status === status
                ? 'brand-border brand-bg-light brand-text font-medium'
                : 'border-slate-200 hover:border-slate-300 text-slate-700'
            }`}
            data-testid={`marital-status-${status.toLowerCase().replace(/\s/g, '-')}`}
          >
            {status}
          </button>
        ))}
      </div>
    </div>
  );
};

export default MaritalStatusStep;
